import { immerable } from "immer";
import { filtersTypeEnum } from "@sttedra_ui/framework";

import { tableViews } from "@/composables/_commons/helper.js";
import { reportsList } from "@/api/reports/reports.api.js";
// import { reportTypes } from "@/composables/_commons/enums.js";

export default class ReportsTableConfig {
  [immerable] = true;

  constructor(
    fromUserHasReports,
    fromUserGroupHasReports,
    buildModal,
    deleteRegister
  ) {
    const fields = [
      {
        field: "AliasCategoria",
        label: "Categoría",
      },
      {
        field: "tipoInforme",
        label: "Tipo de informe",
        sortable: false,
      },
      {
        field: "titulo",
        label: "Título",
      },
      {
        field: "Url",
        label: "URL",
      },
      {
        field: "descripcion",
        label: "Descripción",
      },
    ];

    const advancedFilters = [
      {
        field: "titulo",
        label: "Título",
      },
      {
        field: "alias",
        label: "Alias",
      },
      {
        field: "AliasCategoria",
        label: "Alias de la categoría",
      },
      {
        field: "descripcion",
        label: "Descripción",
      },
    ];

    let actionItems = [
      // {
      //   icon: "description",
      //   command: (event) => buildModal(event, "files"),
      //   extended: true,
      //   disabled: () => true,
      // },
      // {
      //   icon: "analytics",
      //   command: (event) => buildModal(event, "statistics"),
      //   extended: true,
      //   hidden: (data) => data.tipoInforme === reportTypes.PowerBI,
      //   disabled: () => true,
      // },
      {
        label: "Editar",
        icon: "edit",
        command: (event) => buildModal(event, event.data.tipoInforme),
        extended: false,
      },
      {
        label: "Usuarios del informe",
        icon: "group",
        command: (event) => buildModal(event, "users"),
        extended: false,
      },
      {
        label: "Importar usuarios y grupos de otro informe",
        icon: "copy_all",
        command: (event) => buildModal(event, "copy_users_groups"),
        extended: false,
      },
      {
        label: "Borrar",
        icon: "delete",
        command: (event) => deleteRegister(event),
        extended: false,
        classObj: ["delete-action"],
      },
    ];

    let filterItems = [
      {
        type: filtersTypeEnum.GLOBAL,
        fields: advancedFilters,
      },
      {
        type: filtersTypeEnum.ADVANCED,
        fields: advancedFilters,
      },
    ];

    if (fromUserHasReports || fromUserGroupHasReports) {
      actionItems = [];
      filterItems = [];
    }

    let reportListParams = {};

    if (fromUserHasReports) {
      reportListParams = {
        model: "users",
        id: fromUserHasReports,
      };
    } else if (fromUserGroupHasReports) {
      reportListParams = {
        model: "user-groups",
        id: fromUserGroupHasReports,
      };
    }

    return {
      title: fromUserHasReports || fromUserGroupHasReports ? null : "Informes",
      api: (params) => reportsList(params, reportListParams),
      schema: fields,
      actions: {
        header: [],
        item: actionItems,
      },
      filters: filterItems,
      views: tableViews(),
      behaviour: {
        useQuery: false,
      },
    };
  }
}
